import moduleDrilling from "./../store/moduleDrilling.js";
import jobEntries from "./components/jobEntries.vue"
import drillingEntries from "./components/drillingEntries.vue"
import service from "./stagingDailyReportService.js"
import employeeService from '../admin/employees/employeeService';
import stabilisations from "./components/stabilisations.vue"
import deviationTests from "./components/deviationTests.vue"

import { FormWizard, TabContent } from "vue-form-wizard";
import {
  FormLabel
} from "../../shared/components";

export default {
  props: {
    data: {
      type: Object,
      default: () => { }
    }
  },
  components: {
    FormLabel,
    FormWizard,
    TabContent,
    jobEntries,
    drillingEntries,
    stabilisations,
    deviationTests
  },
  data() {
    return {
      selected: [],
      listEmployees: [],
      model: {
        stagingDailyReportId: 0,
        reportDate: null,
        contractNumber: null,
        drillCode: null,
        vendor: null,
        projectCode: null,
        timestamp: null,
        jobEntries: [],
        drillingEntries: [],
        stabilisations: [],
        deviationTests: [],
        companyId: -1
      },
      activeTabIndex: 0,
      selectedTab: 0,
      reportHoles: [],
      projectZones: [],
      project: null,
      isLoaded: false
    };
  },
  computed: {
    title() {
      return this.$t('Drilling.DailyReports.EditTitle', {
        reportDate: this.$options.filters.toDate(this.model.reportDate),
        drillCode: this.model.drillCode
      });
    },

    contracts() {
      return this.$store.state.drilling.contracts.filter(c => c.mainProjectId === Number(this.$store.state.projectId));
    },
    // projectId takes priority over projectCode, matching the staging list's getProjectLabel
    projectLabel() {
      if (this.model.projectId) {
        return this.$store.getters['drilling/getProjectById'](this.model.projectId)?.name ?? this.model.projectCode;
      }
      return this.$store.getters['drilling/getProjectByCode'](this.model.projectCode)?.name ?? this.model.projectCode;
    }
  },

  created() {
    if (!moduleDrilling.isRegistered) {
      this.$store.registerModule("drilling", moduleDrilling);
      moduleDrilling.isRegistered = true;
    }

    if (this.$route.params.stagingDailyReportId !== undefined && this.$route.params.stagingDailyReportId !== null) {
      this.model.stagingDailyReportId = this.$route.params.stagingDailyReportId;
    }

    this.refreshModel();
  },
  mounted() {
    this.$refs.wizard.activateAll();
  },
  methods: {
    returnToList() {
      this.$router.push("/drilling/staging");
    },

    //#region Wizard Methods
    next() {
      this.$refs.wizard.nextTab();
      this.activeTabIndex++;
    },
    previous() {
      this.$refs.wizard.prevTab();
      this.activeTabIndex--;
    },

    //#endregion

    refreshModel() {
      if (this.stagingDailyReportId !== 0) {
        this.$vs.loading();
        this.getReport().finally(() => {
          this.$vs.loading.close();
        })
      }
    },

    getReport() {
      return new Promise((resolve, reject) => {
        service.findById(this.model.stagingDailyReportId, this).then((response) => {
          this.model = response.data.model;
          Promise.all([
            this.getHoles(),
            this.getEmployees()
          ]).then(() => {
            this.isLoaded = true;
            resolve()
          })
            .catch((error) => {
              this.$vs.notify({
                color: "danger",
                title: this.$t("LoadingError"),
                text: error.message
              });
              reject(error)
            })
        }).catch((error) => {
          this.$vs.notify({
            color: "danger",
            title: this.$t("LoadingError"),
            text: error.message
          });
          reject(error)
        })
      });
    },
    getUniqueHoleNumbers() {
      const holeNumbers = new Set();

      // Add hole numbers from drillingEntries
      this.model.drillingEntries.forEach(entry => {
        if (entry.holeNumber) {
          holeNumbers.add(entry.holeNumber);
        }
      });

      // Add hole numbers from deviationTests
      this.model.deviationTests.forEach(entry => {
        if (entry.holeNumber) {
          holeNumbers.add(entry.holeNumber);
        }
      });

      // Add hole numbers from stabilisations
      this.model.stabilisations.forEach(entry => {
        if (entry.holeNumber) {
          holeNumbers.add(entry.holeNumber);
        }
      });

      return Array.from(holeNumbers);
    },
    getProject() {
      const projects = this.$store.state.drilling.projects;
      this.project = projects.find(p => p.projectId === this.model.projectId || p.codes?.some(code => code.trim().toLowerCase() === this.model.projectCode?.trim().toLowerCase()));
    },
    getHoles() {
      return new Promise((resolve, reject) => {
        const holeCodes = this.getUniqueHoleNumbers().join(',');
        this.getProject();
        if (!this.project) {
          this.projectZones = [];
          return Promise.resolve();
        }
        const mainProjectId = Number(this.$store.state.projectId);
        const projectId = this.project.projectId;

        this.$cqrsGet("Drilling/Holes/Search", { params: { mainProjectId, projectId, holeCodes, includeInactiveHoles: true } })
          .then((response) => {
            this.reportHoles = response.data.model;
            resolve(response.data.model)
          })
          .catch((error) => {
            this.$vs.notify({
              color: "danger",
              title: this.$t("LoadingError"),
              text: error.message
            });
            reject(error)
          })
      })
    },
    getEmployees() {
      return new Promise((resolve, reject) => {
        employeeService.fetchEmployeesByCompanyId(this.model.companyId).then((employees) => {
          this.listEmployees = employees.data.model;
          resolve(employees.data.model)
        })
          .catch((error) => {
            this.$vs.notify({
              color: "danger",
              title: this.$t("LoadingError"),
              text: error.message
            });
            reject(error)
          })
      })
    }
  }
};
